import { X } from 'lucide-react';
import { Button } from '../ui/Button';

interface CloseButtonProps {
  onClose: () => void;
  className?: string;
}

export default function CloseButton({ onClose, className }: CloseButtonProps) {
  return (
    <Button variant="ghost" size="sm" onClick={onClose} className={className}>
      <X className="h-4 w-4" />
    </Button>
  );
}
